var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/ranking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ranking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.22484 11.6667H3.33317C2.4165 11.6667 1.6665 12.4167 1.6665 13.3334V18.3334H7.22484V11.6667Z",
    stroke: "#FF6636",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1085 8.33325H8.88346C7.9668 8.33325 7.2168 9.08325 7.2168 9.99992V18.3333H12.7751V9.99992C12.7751 9.08325 12.0335 8.33325 11.1085 8.33325Z",
    fill: "#FF6636",
    fillOpacity: 0.18,
    stroke: "#FF6636",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.6666 14.1667H12.7749V18.3334H18.3332V15.8334C18.3332 14.9167 17.5832 14.1667 16.6666 14.1667Z",
    stroke: "#FF6636",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.4335 1.7251L10.8752 2.60843C10.9335 2.73343 11.0919 2.85009 11.2252 2.86676L12.0252 3.0001C12.5335 3.08343 12.6585 3.45841 12.2919 3.81675L11.6669 4.44175C11.5585 4.55008 11.5002 4.75009 11.5335 4.89175L11.7085 5.65843C11.8502 6.26676 11.5252 6.5001 10.9919 6.18344L10.2419 5.74177C10.1085 5.65844 9.88353 5.65844 9.75019 5.74177L9.00019 6.18344C8.46686 6.5001 8.14186 6.26676 8.28352 5.65843L8.45853 4.89175C8.49186 4.75009 8.43353 4.54175 8.32519 4.44175L7.70852 3.82509C7.34186 3.45842 7.45852 3.09175 7.97519 3.00841L8.77519 2.8751C8.90852 2.8501 9.06686 2.73344 9.12519 2.61677L9.56686 1.73341C9.80852 1.25008 10.1919 1.2501 10.4335 1.7251Z",
    stroke: "#FF6636",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingIcon);
export default __webpack_public_path__ + "static/media/rankingIcon.1606c173588b49ca235302f4b42e2a0c.svg";
export { ForwardRef as ReactComponent };